import { CircularProgress } from '@material-ui/core'
import styled, { css } from 'styled-components/macro'
import { ProgressProps } from '.'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
`

export const Loading = styled(CircularProgress)<ProgressProps>`
  color: ${(props) => props.colorcircularprogress};
`

export const Texto = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    color: ${theme.colors.black};
    font-size: ${theme.font.sizes.large};
  `}
  white-space: pre-line;
  text-align: center;
  line-height: 28px;
`
